import { Business_Types, CSIO_BUSINESS_TYPE } from "../../constants/constants";

export const APP_FILE_NOTICES_LIST = "/notices";

// Business type categories (Policy, Billing, Claim, etc.) used by the "Type"
// field in the edit right panel. Stored on records in the `type` column.
export const NOTICES_BUSINESS_TYPE_OPTIONS: {
  label: string;
  value: string;
}[] = Business_Types.map((type) => ({ label: type, value: type }));

// Manual notice business purposes (used by NOTICE records -> notice_type)
const NOTICES_MANUAL_BUSINESS_PURPOSE_OPTIONS: {
  label: string;
  value: string;
}[] = [
  { label: "Updates", value: "Updates" },
  { label: "Cancellation Notice", value: "Cancellation Notice" },
  { label: "Claim Notice", value: "Claim Notice" },
  { label: "Coverage Change Notice", value: "Coverage Change Notice" },
  { label: "Incorrect Address", value: "Incorrect Address" },
  { label: "Payment Notice", value: "Payment Notice" },
  { label: "Non-Renewal Notice", value: "Non-Renewal Notice" },
  { label: "Underwriting Notice", value: "Underwriting Notice" },
  { label: "Agency Cancellation Advice", value: "Agency Cancellation Advice" },
  {
    label: "NSF Special withdrawal notice",
    value: "NSF Special withdrawal notice",
  },
  {
    label: "Non-NSF special withdrawal notice",
    value: "Non-NSF special withdrawal notice",
  },
  {
    label: "Non-Pay Cancellation Non-Reinstatement Notification",
    value: "Non-Pay Cancellation Non-Reinstatement Notification",
  },
  {
    label: "Request for New Payment Information for a delinquent policy",
    value: "Request for New Payment Information for a delinquent policy",
  },
  { label: "Varied Terms Letter", value: "Varied Terms Letter" },
  {
    label: "Cancellation special withdrawal notice",
    value: "Cancellation special withdrawal notice",
  },
  {
    label: "Please Update Customer Mailing Address",
    value: "Please Update Customer Mailing Address",
  },
  {
    label: "Commercial Past Due Payment",
    value: "Commercial Past Due Payment",
  },
  { label: "Collection notice", value: "Collection notice" },
  { label: "Claim notice", value: "Claim notice" },
  { label: "Non-Renewal notice", value: "Non-Renewal notice" },
  { label: "Underwriting notice", value: "Underwriting notice" },
  { label: "Broker memo", value: "Broker memo" },
  { label: "Metrofax message", value: "Metrofax message" },
  { label: "Payment notice", value: "Payment notice" },
  {
    label: "Initial Adjuster Assignment",
    value: "Initial Adjuster Assignment",
  },
  {
    label: "Credit Card Expiry Notification",
    value: "Credit Card Expiry Notification",
  },
  { label: "Email from client", value: "Email from client" },
  { label: "Other", value: "Other" },
];

// eDoc business purpose types (used by EDOC records -> business_purpose_type).
// Derived from CSIO_BUSINESS_TYPE so every type available in the edit right
// panel is also available in the list filter.
const NOTICES_EDOC_BUSINESS_PURPOSE_OPTIONS: {
  label: string;
  value: string;
}[] = Object.values(CSIO_BUSINESS_TYPE).map(({ value }) => ({
  label: value,
  value,
}));

// Combined, de-duplicated list of all business purpose types (notice + eDoc)
// so the /notices list filter exposes every possible business purpose type.
export const NOTICES_BUSINESS_PURPOSE_OPTIONS: {
  label: string;
  value: string;
}[] = (() => {
  const seen = new Set<string>();
  const combined: { label: string; value: string }[] = [];

  [
    ...NOTICES_MANUAL_BUSINESS_PURPOSE_OPTIONS,
    ...NOTICES_EDOC_BUSINESS_PURPOSE_OPTIONS,
  ].forEach((option) => {
    if (!seen.has(option.value)) {
      seen.add(option.value);
      combined.push(option);
    }
  });

  return combined;
})();

// Map of business type category -> its business purpose options, mirroring
// `Business_Purpose_type` used by the edit right panel. Keyed by the same
// category values as NOTICES_BUSINESS_TYPE_OPTIONS (Policy, Billing, etc.).
export const NOTICES_BUSINESS_PURPOSE_BY_TYPE: {
  [type: string]: { label: string; value: string }[];
} = Object.values(CSIO_BUSINESS_TYPE).reduce((acc, { type, value }) => {
  if (!acc[type]) {
    acc[type] = [];
  }
  acc[type].push({ label: value, value });
  return acc;
}, {} as { [type: string]: { label: string; value: string }[] });

/**
 * Returns the business purpose options for the given selected type.
 * - No type selected -> all purpose options.
 * - A type selected  -> only the purposes belonging to that type, matching
 *   the edit right panel behaviour.
 */
export const getNoticesBusinessPurposeOptions = (
  selectedType?: string
): { label: string; value: string }[] => {
  if (!selectedType) {
    return NOTICES_BUSINESS_PURPOSE_OPTIONS;
  }

  return NOTICES_BUSINESS_PURPOSE_BY_TYPE[selectedType] || [];
};
